import React from 'react';
import { ModuleHeader, useEditContext } from '@xingternal/pages-common';
import {
  getTrackingUrl,
  trackClickEditorProfile,
} from '@xingternal/pages-tracking';

import kununuLogo from '@common/assets/kununuLogo.svg';
import styles from './Header.css';

type Props = {
  loading: boolean;
  profileUrl?: string;
};

const Header = ({ loading, profileUrl }: Props) => {
  const { isEditing } = useEditContext();

  return (
    <ModuleHeader
      headlineCopyKey="EP_KUNUNU_HEADLINE"
      externalEditInfo={
        !loading && isEditing
          ? {
              copyKey: 'EP_KUNUNU_EDIT_HINT',
              ctaCopyKey: 'EP_KUNUNU_EDIT_HINT_CTA',
              ctaUrl: getTrackingUrl({
                to: profileUrl,
                trackingKey: 'viewProfileAsEditor',
              }),
              cyTestId: 'EDIT_HINT_KUNUNU',
              buttonProps: {
                onClick: () => trackClickEditorProfile(),
              },
            }
          : null
      }
    >
      <img src={kununuLogo} className={styles.logo} alt="Kununu logo" />
    </ModuleHeader>
  );
};

export default Header;
